import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khoản thời gian thống kê báo cáo: ", -1)
const _hoisted_5 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Không có báo cáo. ")
const _hoisted_7 = { class: "p-fluid" }
const _hoisted_8 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_9 = { class: "p-field p-col p-col-12 p-md-8 p-lg-8" }
const _hoisted_10 = { class: "flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Panel, { header: "BÁO CÁO THỐNG KÊ TIÊM VẮC XIN" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_Calendar, {
                id: "date",
                modelValue: $setup.dateLaoDong,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.dateLaoDong) = $event)),
                selectionMode: "range",
                dateFormat: "dd/mm/yy",
                showButtonBar: true,
                showIcon: true,
                manualInput: false,
                monthNavigator: true,
                yearNavigator: true,
                yearRange: "2000:2100",
                onDateSelect: _cache[1] || (_cache[1] = ($event: any) => ($setup.selectCalendarLaoDong())),
                onClearClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.clearCalendar()))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_DataTable, {
                value: $setup.listBaoCao,
                paginator: true,
                stripedRows: "",
                rows: 10,
                rowsPerPageOptions: [10,25,50],
                rowHover: true,
                paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                globalFilterFields: ['tuNgay','denNgay','nguoiBaoCaoCao','donViBaoCao'],
                currentPageReportTemplate: "Có tất cả {totalRecords} báo cáo",
                filters: _ctx.filters,
                "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters) = $event)),
                style: {"font-size":"13px"}
              }, {
                empty: _withCtx(() => [
                  _hoisted_6
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    field: "tuNgay",
                    dataType: "date",
                    header: "Từ ngày",
                    sortable: ""
                  }, {
                    body: _withCtx(({data}) => [
                      _createTextVNode(_toDisplayString($setup.formatDateTime(data.tuNgay)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "denNgay",
                    dataType: "date",
                    header: "Đến ngày",
                    sortable: ""
                  }, {
                    body: _withCtx(({data}) => [
                      _createTextVNode(_toDisplayString($setup.formatDateTime(data.denNgay)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "thoiGianBaoCao",
                    dataType: "date",
                    header: "Thời gian báo cáo",
                    sortable: ""
                  }, {
                    body: _withCtx(({data}) => [
                      _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianBaoCao)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "nguoiBaoCaoCao",
                    header: "Người báo cáo",
                    sortable: ""
                  }),
                  _createVNode(_component_Column, {
                    field: "donViBaoCao",
                    header: "Đơn vị",
                    sortable: ""
                  }),
                  _createVNode(_component_Column, {
                    field: "",
                    header: ""
                  }, {
                    body: _withCtx(({data}) => [
                      _createVNode(_component_Button, {
                        label: "Tải báo cáo",
                        icon: "pi pi-download",
                        onClick: ($event: any) => ($setup.downLoadFileExport(data.id)),
                        severity: "secondary",
                        raised: ""
                      }, null, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value", "filters"])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_ConfirmDialog, { group: "templating" }, {
            message: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", null, _toDisplayString(slotProps.message.message), 1)
              ])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 64))
}